import LanguageHelper from "../helpers/LanguageHelper";
const language = LanguageHelper.getLanguage();

export const roles = {
  ROLE_ADMIN: "Admin",
  ROLE_OBSERVER: "Gözlemci",
  ROLE_BACKEND_DEVELOPER: "Backend Geliştirici",
  ROLE_FRONTEND_DEVELOPER: "Frontend Geliştirici",
  ROLE_SERVICE: "Servis",
};

export const permissions = {
  DASHBOARD: "Anasayfa",
  USER: "Kullanıcılar",
  SIGN_IN_HISTORY: "Oturum Geçmişi",
  GDZ_PROD_FULL: "GDZ Canlı (Tam Yetki)",
  GDZ_PROD_READ_ONLY: "GDZ Canlı (Sadece Okuma)",
  ADM_PROD_FULL: "ADM Canlı (Tam Yetki)",
  ADM_PROD_READ_ONLY: "ADM Canlı (Sadece Okuma)",
  GDZ_ADM_DEV_FULL: "GDZ ADM Dev (Tam Yetki)",
  GDZ_ADM_DEV_READ_ONLY: "GDZ ADM Dev (Sadece Okuma)",
  GDZ_ADM_TEST_FULL: "GDZ ADM Test (Tam Yetki)",
  GDZ_ADM_TEST_READ_ONLY: "GDZ ADM Test (Sadece Okuma)",
  MEDAS_DEV_FULL: "MEDAS Dev (Tam Yetki)",
  MEDAS_DEV_READ_ONLY: "MEDAS Dev (Sadece Okuma)",
  MEDAS_TEST_FULL: "MEDAS Test (Tam Yetki)",
  MEDAS_TEST_READ_ONLY: "MEDAS Test (Sadece Okuma)",
  MEDAS_PROD_FULL: "MEDAS Canlı (Tam Yetki)",
  MEDAS_PROD_READ_ONLY: "MEDAS Canlı (Sadece Okuma)",
  VEDAS_DEV_FULL: "VEDAS Dev (Tam Yetki)",
  VEDAS_DEV_READ_ONLY: "VEDAS Dev (Sadece Okuma)",
  VEDAS_PROD_FULL: "VEDAS Canlı (Tam Yetki)",
  VEDAS_PROD_READ_ONLY: "VEDAS Canlı (Sadece Okuma)",
  OEDAS_DEV_FULL: "OEDAS Dev (Tam Yetki)",
  OEDAS_DEV_READ_ONLY: "OEDAS Dev (Sadece Okuma)",
  OEDAS_PROD_FULL: "OEDAS Canlı (Tam Yetki)",
  OEDAS_PROD_READ_ONLY: "OEDAS Canlı (Sadece Okuma)",
  YEDAS_DEV_FULL: "YEDAS Dev (Tam Yetki)",
  YEDAS_DEV_READ_ONLY: "YEDAS Dev (Sadece Okuma)",
  YEDAS_PROD_FULL: "YEDAS Canlı (Tam Yetki)",
  YEDAS_PROD_READ_ONLY: "YEDAS Canlı (Sadece Okuma)",
  ZOREN_DEV_FULL: "ZOREN Dev (Tam Yetki)",
  ZOREN_DEV_READ_ONLY: "ZOREN Dev (Sadece Okuma)",
  ZOREN_PROD_FULL: "ZOREN Canlı (Tam Yetki)",
  ZOREN_PROD_READ_ONLY: "ZOREN Canlı (Sadece Okuma)",
  ISGHUB_FULL: "ISG Hub (Tam Yetki)",
  DEMO_FULL: "ISG Demo (Tam Yetki)",
  DEMO_READ_ONLY: "ISG Demo (Sadece Okuma)",
  DOCUMENTATIONHUB_READ_ONLY: "Dokümantasyon Hub (Sadece Okuma)",
  DOCUMENTATIONHUB_FULL: "Dokümantasyon Hub (Tam Yetki)",
  PINCIDENTPUBLIC_READ_ONLY: "Pincident Public (Sadece Okuma)",
  PINCIDENTPUBLIC_FULL: "Pincident Public (Tam Yetki)",
  IDEALKONTRAT_READ_ONLY: "I-deal Kontrat (Sadece Okuma)",
  IDEALKONTRAT_FULL: "I-deal Kontrat (Tam Yetki)",
  TICKET: "Destek Talepleri",
  OSGB_IZLEME_FULL: "OSGB İzleme (Tam Yetki)",
  OSGB_IZLEME_READ_ONLY: "OSGB İzleme (Sadece Okuma)",
};

export const documentTypes = {
  WORKPLACE_PHYSICIAN: "İşyeri Hekimi",
  OHS_SPECIALIST: "İSG Uzmanı",
};

export const definitionState = {
  true: "Tanımlı",
  false: "Tanımsız",
};

export const activityState = {
  true: "Aktif",
  false: "Aktif Değil",
};

export const succession = {
  true: language.history.successful,
  false: language.history.unsuccessful,
};

export const platform = {
  MOBILE: "Mobile",
  WEB: "Web",
};

export const statusTranslations = {
  SUCCESS: "Başarılı",
  COMPLETED: "Tamamlandı",
  FAILED: "Hatalı",
  FAILURE: "Hatalı",
  IN_PROGRESS: "Devam Ediyor",
  READY_TO_DEPLOY: "Paket Oluşturuldu, Deploy İçin Hazır",
  DEPLOYED: "Deploy Edildi",
};

export const latestArtifactStatusTranslations = {
  READY_TO_DEPLOY: "Paket Oluşturuldu, Deploy İçin Hazır",
  FAILED: "Paket Oluşturulamadı",
  IN_PROGRESS: "Paket Oluşturuluyor",
  DEPLOYED: "Deploy Atıldı",
};
